import { Reducer } from 'redux';
import { RootState } from '../../store/rootReducer';
import {
    AiSupportedMarkingIntroActions,
    CLOSE_AI_SUPPORTED_MARKING_INTRO,
    OPEN_AI_SUPPORTED_MARKING_INTRO,
    SET_DONT_SHOW_AGAIN,
} from './actions';
import {
    readDontShowAgainForUserAndAssessment,
    writeDontShowAgainForUserAndAssessment,
} from './dontShowAgainPreference';

export interface AiSupportedMarkingIntroState {
    open: boolean;
    pendingWorkspaceId?: string;
    dontShowAgain: boolean;
}

const initialState: AiSupportedMarkingIntroState = {
    open: false,
    pendingWorkspaceId: undefined,
    dontShowAgain: false,
};

type AiSupportedMarkingIntroReducer = Reducer<AiSupportedMarkingIntroState, AiSupportedMarkingIntroActions>;

export const aiSupportedMarkingIntroReducer: AiSupportedMarkingIntroReducer = (state = initialState, action) => {
    switch (action.type) {
    case OPEN_AI_SUPPORTED_MARKING_INTRO: {
        const { pendingWorkspaceId, userId, assessmentRunId } = action.payload;
        return {
            ...state,
            open: true,
            pendingWorkspaceId,
            dontShowAgain: readDontShowAgainForUserAndAssessment(userId, assessmentRunId),
        };
    }
    case CLOSE_AI_SUPPORTED_MARKING_INTRO:
        return { ...state, open: false, pendingWorkspaceId: undefined };
    case SET_DONT_SHOW_AGAIN: {
        const { value: dontShowAgain, userId, assessmentRunId } = action.payload;
        writeDontShowAgainForUserAndAssessment(userId, assessmentRunId, dontShowAgain);
        return { ...state, dontShowAgain };
    }
    default:
        return state;
    }
};

export const getAiSupportedMarkingIntroState = (
    state: RootState
): AiSupportedMarkingIntroState => (state as any).aiSupportedMarkingIntro || initialState;
